module.exports = __webpack_public_path__ + "static/media/Picture6.6585c26c.png";